import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE from '../utils/api';

const LicenseStatus = () => {
  const [license, setLicense] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLicense();
  }, []);

  const fetchLicense = async () => {
    try {
      const response = await axios.get(`${API_BASE}/license/current`);
      setLicense(response.data);
    } catch (error) {
      // License not found or error
    } finally {
      setLoading(false);
    }
  };

  if (loading || !license) {
    return null;
  }

  const getStatusColor = () => {
    if (!license.isActive) return 'bg-gray-100 border-gray-300';
    if (license.isExpired) return 'bg-red-100 border-red-300';
    if (license.daysRemaining <= 30) return 'bg-yellow-100 border-yellow-300';
    return 'bg-green-100 border-green-300';
  };

  const getStatusText = () => {
    if (!license.isActive) return '⊘ License Inactive';
    if (license.isExpired) return '✗ License Expired';
    if (license.daysRemaining <= 30) return `⚠️ Expiring in ${license.daysRemaining} days`;
    return `✓ License Active (${license.daysRemaining} days remaining)`;
  };

  return (
    <div className={`border rounded-lg p-3 text-center text-sm font-medium ${getStatusColor()}`}>
      {getStatusText()}
    </div>
  );
};

export default LicenseStatus;
